import { getAccessToken } from '../../Utils/storageUtils';
import pfmClientAxiosInstance from './interceptor';

export const getDetails = (data: any) => {
  return pfmClientAxiosInstance.get(
    `${process.env.REACT_APP_PFM_CLIENT_BASEURL}/dashboard/get-details/${data.type}`,
    {
      headers: {
        Authorization: `Bearer ${getAccessToken()}`,
      },
    }
  );
};

export const getAnalyticsStatus = () => {
  return pfmClientAxiosInstance.get(
    `${process.env.REACT_APP_PFM_CLIENT_BASEURL}/dashboard/analytics-status`,
    {
      headers: {
        Authorization: `Bearer ${getAccessToken()}`,
      },
    }
  );
};

export const getStockInshights = (rangeFilter: string) => {
  return pfmClientAxiosInstance.get(
    `${process.env.REACT_APP_PFM_CLIENT_BASEURL}/dashboard/stocks/insights?rangeFilter=${rangeFilter}`,
    {
      headers: {
        Authorization: `Bearer ${getAccessToken()}`,
      },
    }
  );
};

export const getOverallFields = () => {
  return pfmClientAxiosInstance.get(
    `${process.env.REACT_APP_PFM_CLIENT_BASEURL}/dashboard/stocks/overallFields`,
    {
      headers: {
        Authorization: `Bearer ${getAccessToken()}`,
      },
    }
  );
};

export const getStocksHoldings = (data: any) => {
  return pfmClientAxiosInstance.get(
    `${process.env.REACT_APP_PFM_CLIENT_BASEURL}/dashboard/stocks/holdings`,
    {
      headers: {
        Authorization: `Bearer ${getAccessToken()}`,
      },
    }
  );
};

export const fetchRawData = (data: any) => {
  return pfmClientAxiosInstance.post(
    `${process.env.REACT_APP_PFM_CLIENT_BASEURL}/dashboard/raw-data`,
    data,
    {
      headers: {
        Authorization: `Bearer ${getAccessToken()}`,
      },
    }
  );
};

export const getTransactions = (data: any, config?: any) => {
  return pfmClientAxiosInstance.post(
    `${process.env.REACT_APP_PFM_CLIENT_BASEURL}/dashboard/transactions?${
      config?.page !== undefined ? `page=${config?.page}` : ''
    }${config?.page !== undefined ? `&size=${config?.pageSize}` : ''}`,
    data,
    {
      headers: {
        Authorization: `Bearer ${getAccessToken()}`,
      },
    }
  );
};


export const getCashFlow = (data: any) => {
  return pfmClientAxiosInstance.post(
    `${process.env.REACT_APP_PFM_CLIENT_BASEURL}/dashboard/get-cash-flow`,
    data,
    {
      headers: {
        Authorization: `Bearer ${getAccessToken()}`,
      },
    }
  );
};

export const sendSessionId= (data: any) => {
    return pfmClientAxiosInstance.post(
        `${process.env.REACT_APP_PFM_CLIENT_BASEURL}/dashboard/sessionId`,
        data,
        {
            headers: {
                Authorization: `Bearer ${getAccessToken()}`,
            },
        }
    );
}

export const getMonthFilterTransactions = (data: string) => {
  return pfmClientAxiosInstance.get(
    `${process.env.REACT_APP_PFM_CLIENT_BASEURL}/dashboard/transaction-months/${data}`,
    {
      headers: {
        Authorization: `Bearer ${getAccessToken()}`,
      },
    }
  );
};

export const refreshApi = () => {
  return pfmClientAxiosInstance.post(
    `${process.env.REACT_APP_PFM_CLIENT_BASEURL}/dashboard/data/refresh`,
    {},
    {
      headers: {
        Authorization: `Bearer ${getAccessToken()}`,
      },
    }
  );
};

export const revokeConsentAPI = (data: { referenceId: string }) => {
  return pfmClientAxiosInstance.post(
    `${process.env.REACT_APP_PFM_CLIENT_BASEURL}/dashboard/consent/revoke`,
    data,
    {
      headers: {
        Authorization: `Bearer ${getAccessToken()}`,
      },
    }
  );
};

export const getTrends = (data: any, config?: any) => {
  return pfmClientAxiosInstance.post(
    `${process.env.REACT_APP_PFM_CLIENT_BASEURL}/dashboard/trends`,
    data,
    {
      headers: {
        Authorization: `Bearer ${getAccessToken()}`,
      },
    }
  );
};

export const getListOfCategories = (data: any) => {
  return pfmClientAxiosInstance.post(
    `${process.env.REACT_APP_PFM_CLIENT_BASEURL}/dashboard/account/categoryCode`,
    data,
    {
      headers: {
        Authorization: `Bearer ${getAccessToken()}`,
      },
    }
  );
};
